var render, staticRenderFns
import script from "./SideSMenu.vue?vue&type=script&lang=js"
export * from "./SideSMenu.vue?vue&type=script&lang=js"
import style0 from "./SideSMenu.vue?vue&type=style&index=0&id=2a651f20&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports